import { Controller, useForm } from 'react-hook-form';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { DatePicker } from 'antd';
import { t } from 'i18next';
import dayjs from 'dayjs';
import { useAppSelector } from 'core/store/hooks';
import LinksButton from 'shared/design-system/components/links-button';
import { filtersDashboardStoricoUsedSelector } from '../_redux/selectors';
import { CHIAVI_STORICO, getDefaultDataConfronto } from '../_hooks/storico-hooks/useStoricoConfronto';
import './filters-dashboard-storico.scss';

export const filtersDashboardStoricoData: any = {
  fkChiaveMisura: undefined,
  dataConfronto: getDefaultDataConfronto(),
};

interface Props {
  onSubmit: any;
  handleReset: () => void;
}

const FiltersDashboardStorico = ({ onSubmit, handleReset }: Props) => {
  const filterUsed = useAppSelector(filtersDashboardStoricoUsedSelector);
  const { control, handleSubmit, reset } = useForm({
    defaultValues: filtersDashboardStoricoData,
    values: filterUsed,
  });

  const Reset = () => {
    reset();
    handleReset();
  };

  return (
    <Form className="grid" onSubmit={handleSubmit(onSubmit)}>
      <Row>
        <Col sm="3">
          <Form.Label>{t('dashboard.storico.filters.key')}</Form.Label>
          <Controller
            name="fkChiaveMisura"
            control={control}
            render={({ field }) => (
              <div className="storico-key-buttons">
                {CHIAVI_STORICO.map((chiave) => (
                  <LinksButton
                    key={chiave.id}
                    type="button"
                    className={`${field.value === chiave.id ? 'btn-links' : 'btn-links-outline'} px-2`}
                    // Un secondo click deseleziona: nessun pulsante attivo = tutte le misure
                    onClick={() => field.onChange(field.value === chiave.id ? undefined : chiave.id)}
                  >
                    {t(chiave.labelKey)}
                  </LinksButton>
                ))}
              </div>
            )}
          />
        </Col>
        <Col sm="3">
          <Form.Label>{t('dashboard.storico.filters.comparison-date')}</Form.Label>
          <Controller
            name="dataConfronto"
            control={control}
            defaultValue={undefined}
            render={({ field }) => (
              <DatePicker
                allowClear
                placeholder={`${t('dashboard.storico.filters.comparison-date-placeholder')}`}
                className="w-100"
                ref={field.ref}
                name={field.name}
                onBlur={field.onBlur}
                format="DD/MM/YYYY"
                value={field.value ? dayjs(field.value) : undefined}
                size="large"
                onChange={(date: any) => {
                  field.onChange(date ? date.format('YYYY-MM-DD') : undefined);
                }}
              />
            )}
          />
        </Col>
      </Row>

      <div className="d-flex mt-3">
        <div className="d-flex ms-auto">
          <Button className="btn text-danger trash-btn" type="button" variant="icon" onClick={Reset}>
            <i className="fa-regular fa-trash-can me-2" />
            {t('project-list.delete-filters')}
          </Button>
          <LinksButton type="submit" className="btn-sm btn-primary btn-links px-4">
            <i className="fa-solid fa-magnifying-glass me-2" />
            {t('project-list.search')}
          </LinksButton>
        </div>
      </div>
    </Form>
  );
};

export default FiltersDashboardStorico;
